import { Company, CompanyCategory } from '../integrations/crossborderit';
import { intersection } from 'ramda';

export const hasAnyCategory = (
  categories: CompanyCategory[],
  company: Company
) => !!intersection(categories, company?.companyCategories || []).length;
